<template>
  <div class="login">
    <img alt="Vue logo" src="../assets/ppyatc.jpg" width="400" height="200" />
    <h3>ลงชื่อเข้าใช้</h3>
    <input type="text" v-model="email" placeholder="อีเมล์" /><br />
    <input
      type="password"
      v-model="password"
      @keyup.enter="login"
      placeholder="พาสเวิร์ด"
    /><br />
    <button @click="login">เข้าสู่ระบบ</button>
    <div class="copyright">&copy; สงวนลิขสิทธิ์ PPYATC.com V.1.2.0</div>
  </div>
</template>

<script>
import db from "@/db";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    login() {
      db.login(this.email, this.password).then(() =>
        this.$router.replace("home")
      );
    }
  }
};
</script>

<style scoped>
.login {
  margin-top: 40px;
  text-align: center;
}
input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}
button {
  margin-top: 20px;
  width: 10%;
  cursor: pointer;
}
p {
  margin-top: 40px;
  font-size: 13px;
}
p a {
  text-decoration: underline;
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  input {
    width: 80%;
    font-size: 1.2em;
  }
  button {
    width: 40%;
    font-size: 1.3em;
  }
}

.copyright {
  margin-top: 50px;
}
</style>
